import { axiosInstance } from 'apis';
import { getBaseURL } from 'utility/baseURL';

const baseURL = getBaseURL();

const EStore = {
	info: baseURL + '/Keepasite/GetSupplierInfo',
	similar: baseURL + '/Keepasite/GetRelatedSupplier',
	branches: baseURL + '/keepasite/SupplierBranchFilter',
	widget: baseURL + `/keepasite/GetWidgetsKeepaSite`,
	installment: baseURL + `/keepasite/GetSupplierInstallmentsCondition`,
};
const storeAPIs = {
	info: (data, option = {}) => axiosInstance.post(EStore.info, data, option),
	similar: (data, option = {}) => axiosInstance.post(EStore.similar, data, option),
	branches: (data, option = {}) => axiosInstance.post(EStore.branches, data, option),
	getWidget: (data, option = {}) => axiosInstance.post(EStore.widget, data, option),
	getInstallment: (data, option = {}) => axiosInstance.post(EStore.installment, data, option),
};

export { EStore, storeAPIs };
